import axios from '@/plugins/axios'
import { refreshAxiosInstance } from '@/plugins/axios'

const state = {
    // access_token: localStorage.getItem('access_token') || '',
    // refresh_token: localStorage.getItem('refresh_token') || '',
    resources: [],
    refresh_token_call: null,
    permissions: [],
    profile: undefined,
    stored_name: document.cookie,
    restoring_session: false,
    national_facility_ids: []
}

const getters = {
    refresh_token_call(state) {
        return state.refresh_token_call
    },
    restoring_session(state) {
        return state.restoring_session
    },
    resources(state) {
        return state.resources
    },
    userinfo(state) { // Keep userinfo for legacy reasons
        return state.profile
    },
    profile(state) {
        return state.profile
    },
    permissions(state) {
        return state.permissions
    },
    isLoggedIn(state) {
        return state.profile !== undefined
    },
    isAdmin(state, getters) {
        return getters.isLoggedIn && getters.profile?.roles?.map(p => p.name.toLowerCase()).indexOf("administrator") !== -1 || false
    },
    allowed : (state, getters) => (permission) => {
        return getters.isLoggedIn && getters.permissions.filter(p => p === permission.toLowerCase()).length === 1 || false
    }
}

const actions = {
    async login({ commit }, options) {
        // Send credentials to API login endpoint
        return axios({
            url: '/auth/login',
            method: 'POST',
            data: {
                password: options.password,
                email: options.email
            }
        }).then (response => {
            // API will respond with the profile, permissions and accesible resources
            // so set them up
            commit('SET_PROFILE', response.data.profile || undefined)
            commit('SET_PERMISSIONS', response.data.permissions || [])
            commit('SET_RESOURCES', response.data.resources || [])

            // Also save refresh token so we can restore the session
        })
    },
    logout({commit, dispatch}) {
        return axios({
            url: '/auth/logout',
            method: 'POST'
        }).catch(() => {})
        .finally (() => {
            commit('SET_PROFILE', undefined)
            commit('SET_PERMISSIONS', [])
            dispatch ('refreshAvailableResources')
        })
    },
    refreshAccessToken ({commit, getters, dispatch}) {
        // Send credentials to API login endpoint
        commit('SET_TOKEN_REFRESH_STATE',
            refreshAxiosInstance({
                url: '/auth/refresh-token',
                method: 'POST'
            }).then (response => {
                // API will respond with the profile, permissions and accesible resources
                // so set them up
                commit('SET_PROFILE', response.data.profile || undefined)
                commit('SET_PERMISSIONS', response.data.permissions || [])
                commit('SET_RESOURCES', response.data.resources || [])
                commit('SET_TOKEN_REFRESH_STATE', null)
            }).catch(() => { dispatch('logout') })
        )

        return getters.refresh_token_call
    },
    restoreSession({commit, dispatch}) {
        commit('SET_RESTORING_SESSION', true)

        return refreshAxiosInstance({
            url: '/auth/restore',
            method: 'POST'
        })
        .then(response => {
            // API will respond with the profile, permissions and accesible resources
            // so set them up
            commit('SET_PROFILE', response.data.profile || undefined)
            commit('SET_PERMISSIONS', response.data.permissions || [])
            commit('SET_RESOURCES', response.data.resources || [])
            commit('SET_RESTORING_SESSION', false)
        })
        .catch(() => {
            dispatch('logout')
        })
    },
    refreshAvailableResources ({commit}) {
        return axios({
            url: '/auth/resources',
            method: 'GET'
        }).then (response => {
            // API will respond with the profile, permissions and accesible resources
            // so set them up
            commit('SET_RESOURCES', response.data || [])
        })
    },
    resetPassword({commit}, resetPassword) {
        commit('RESET_PASSWORD', resetPassword)
    },
    forgotPassword({commit}, forgotPassword) {
        commit('FORGOT_PASSWORD', forgotPassword)
    },
    hasPermission ({getters}, permission) {
        return getters.isLoggedIn && getters.permissions.filter(p => p === permission.toLowerCase()).length === 1 || false
    },
    hasRole ({getters}, role) {
        const roleList = getters.profile?.roles?.map (r => r.name.toLowerCase())
        return getters.isLoggedIn && roleList.includes(role) || roleList.includes('administrator')
    }
}

// mutations
const mutations = {
    SET_PROFILE(state, payload) {
        state.profile = payload
    },
    SET_PERMISSIONS(state, payload) {
        state.permissions = payload.map(p => p.code.toLowerCase() || p.toLowerCase())
    },
    SET_RESOURCES(state, payload) {
        state.resources = payload
        state.national_facility_ids = []

        if (state.resources.facilities) {
            state.national_facility_ids = state.resources.facilities.map(facility => facility.id)
        }
    },
    SET_TOKEN_REFRESH_STATE(state, payload) {
        state.refresh_token_call = payload
    },
    SET_RESTORING_SESSION (state, payload) {
        state.restoring_session = payload
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}